	export const readToken = (state) => state.accessToken;
	export const readCredentials = (state) => state.credentials;
	export const readHash = (state) => state.hash;
	export const readError = (state) => {
		return state.error == "Incorrect username or password"
			? "Usuario y/o contraseña no validos"
			: state.error;
	}
